import { Injectable, inject, signal } from '@angular/core';
import { ExpenditureEntryService } from '../project-calculation-form/services/expenditure-entry.service';
import { ProjectMemberService } from '../../services/project-member.service';
import { ProjectDataService } from '../../../state-and-data-handling/project-data.service';
import { assert } from '../../../../../../core/assert/assert';
import { ProjectMemberGridRow } from '../../../../shared/project-detail-types';
import { ExpenditureRateEntry } from '../../../../../../core/models/project/project-expenditure-entry.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectMemberGridService {
  public gridData = signal<ProjectMemberGridRow[]>([]);

  // DI
  private readonly expenditureEntryService = inject(ExpenditureEntryService);
  private readonly projectMemberService = inject(ProjectMemberService);
  private readonly projectDataService = inject(ProjectDataService);

  public createEmptyMemberGridDRow(): ProjectMemberGridRow {
    return {
      member: null,
      budgetSeconds: 0,
      deductCostsFromBudget: true,
      expenditureRateHistory: [
        this.expenditureEntryService.createExpenditureEntry(
          0,
          this.projectDataService.getProjectClone().startsAt,
          0,
        ),
      ],
    };
  }

  public openNewExpenditureRateDialog(
    memberGridRow: ProjectMemberGridRow,
    applyResult: (entries: ExpenditureRateEntry[]) => void,
  ): void {
    this.expenditureEntryService.openNewExpenditureRateDialog(
      memberGridRow.expenditureRateHistory,
      (entries) => applyResult(entries),
    );
  }

  public deleteGridData(): void {
    this.gridData.set([]);
  }

  public removeMember(memberGridRow: ProjectMemberGridRow): void {
    // Remove
    const index = this.gridData().findIndex((row) => row.member.id === memberGridRow.member.id);
    assert(index >= 0, 'Project member grid row could not be found.');
    this.gridData().splice(index, 1);

    // Sync
    this.projectMemberService.syncProjectModel(
      this.gridData(),
      this.projectDataService.getProjectClone(),
    );
    this.projectDataService.userOperationConducted$.next(true);
  }
}
